import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Taxset Name",
    "Description",
    "Status",
    "Actions"
  ];
  
  export const TABLE_DATA = [
    { id: 1, name: "8890", description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, name: "8890", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, name: "8890", description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Taxset Name": "tax_name",
    "Description":"tax_desc",    
    "Status": "status",
    "Actions": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };